export interface RecommendationsCarouselSlideBreakpoints {
  0?: number;
  250?: number;
  500?: number;
  750?: number;
  1000?: number;
  1250?: number;
}

/**
 * Mirrors desktop carousel `breakpoints` in `recommendationsSlider.tsx` (!displayGrid).
 */
export function getRecommendationsCarouselSlidesPerView(
  width: number,
  slideBreakpoints: RecommendationsCarouselSlideBreakpoints | undefined,
): number {
  if (width >= 1250) return slideBreakpoints?.[1250] ?? 4;
  if (width >= 1000) return slideBreakpoints?.[1000] ?? 3;
  if (width >= 750) return slideBreakpoints?.[750] ?? 2;
  if (width >= 500) return slideBreakpoints?.[500] ?? 3;
  if (width >= 250) return slideBreakpoints?.[250] ?? 2;
  return slideBreakpoints?.[0] ?? 1;
}
